
import {
  onUnmounted, defineComponent, ref,
} from 'vue';
import { useRouter, } from 'vue-router';
import {
  Input,
  message,
  Select,
} from 'ant-design-vue';
import moment from 'moment';
import { assetsImg, } from '@/configs/index';

import { postRequest, } from '@/request/request';
import { md5Password, } from '@/utils/index';

const { sysConfig, } = window as any;

const { loginBg, } = assetsImg;
const { Option, } = Select;

export default defineComponent({
  components: {
    Select,
    Option,
    Input,
  },
  props: {
    fireSpreadPredictItemObj: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    tempWindDirection: {
      type: Number,
      default: () => 0,
      required: true,
    },
  },
  setup (props, context) {
    const router = useRouter();
    const textValue = ref('');
    const tempObj = {
      province: '',
      city: '',
      county: '',
      company: '',
      time: 3,
      applicant: '',
      pwd: '',
      applicantMobile: '',
      email: '',
    };
    const selectValue: any = ref(tempObj);
    const provinceDataArr:any = ref([]);
    const cityDataArr:any = ref([]);
    const countyDataArr:any = ref([]);

    /**
     * 获取下拉省级数据
     * @param {number} type 1、省级  2、市级 3、县
     * @param {string} id id
     * @returns {void}
     */
    const getRegionInfoFunc = (type: number, id?: string) => {
      const params = {
        regionLevel: type,
        id: type === 1 ?
          null :
          id,
      };

      postRequest('/openUser/queryRegion', params)
        .then(({ data, }: any) => {
          if (type === 1) {
            provinceDataArr.value = data.map((item: any) => ({
              value: item.province,
              id: item.id,
              label: item.province,
            }));
          } else if (type === 2) {
            cityDataArr.value = data.map((item: any) => ({
              value: item.city,
              id: item.id,
              label: item.city,
            }));
            cityDataArr.value.unshift({
              value: '',
              label: '不选择',
            });
            countyDataArr.value = [];
            selectValue.value.city = '';
            selectValue.value.county = '';
          } else if (type === 3) {
            countyDataArr.value = data.map((item: any) => ({
              value: item.county,
              id: item.id,
              label: item.county,
            }));
            countyDataArr.value.unshift({
              value: '',
              label: '不选择',
            });
            selectValue.value.county = '';
          }
        });
    };

    /**
     * 获取下拉省级数据，然后调用市级查询
     * @returns {void}
     */
    const handleChangeProvince = (value: any,opt:any) => {
      const { id, } = opt;

      getRegionInfoFunc(2, id);
    };

    /**
     * 获取下拉市级数据，然后调用县级查询
     * @returns {void}
     */
    const handleChangeCity = (value: any,opt:any) => {
      const { id, } = opt;

      getRegionInfoFunc(3, id);
    };

    getRegionInfoFunc(1);

    /**
     * 提交数据
     * @returns {void}
     */
    const submitData = () => {
      const phoneReg = /^1[3,4,5,6,7,8,9][0-9]{9}$|[a-z]/;
      // 字母+数字正则
      const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{10}$/;

      const {
        company,applicant,applicantMobile,email,province,city,county,
      } = selectValue.value;

      if (!province) {
        return message.warning('账号区域不能为空！');
      }
      if (!selectValue.value.company) {
        return message.warning('使用组织不能为空！');
      }
      if (!selectValue.value.applicant) {
        return message.warning('用户不能为空！');
      }
      if (!selectValue.value.pwd) {
        return message.warning('密码不能为空！');
      }
      if (!pwdReg.test(selectValue.value.pwd)) {
        return message.warning('密码格式不正确，请设置为10位长度的字母和数字组合！',4);
      }
      if (!selectValue.value.applicantMobile) {
        return message.warning('申请人电话不能为空！');
      }
      if (!phoneReg.test(selectValue.value.applicantMobile)) {
        return message.warning('手机号/账号格式不正确');
      }

      const md5Pwd = md5Password(selectValue.value.pwd, selectValue.value.applicantMobile);

      const params = {
        province,
        city,
        county,
        companyName: selectValue.value.company,
        accountName: applicant,
        expirationMonths: selectValue.value.time,
        tel: selectValue.value.applicantMobile,
        password: md5Pwd,
        accountType: 0,
        isOpen: 0,
      };

      postRequest('/openUser/registerTrialUser', params)
        .then(({ data, }: any) => {
          message.success('注册成功，待审核！');
          textValue.value = '';
          selectValue.value = {};
          selectValue.value.time = 3;
        });
    };

    const toLogin = () => {
      router.push('/login');
    };

    onUnmounted(() => {
      textValue.value = '';
      selectValue.value = tempObj;

      provinceDataArr.value = [];
      cityDataArr.value = [];
      countyDataArr.value = [];
    });

    const filterOption = (input: any, option: any) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return {
      moment,
      textValue,
      selectValue,
      provinceDataArr,
      cityDataArr,
      countyDataArr,
      toLogin,
      handleChangeProvince,
      handleChangeCity,
      submitData,
      filterOption,
      loginBg,
      sysConfig,
    };
  },
});
